import ApiService from "@/services/api.service";
import Vue from 'vue';

const route = 'leads';

const administrators = {
    all(_limit, _currentPage, _params) {
        return new Promise((resolve, reject) => {
            var params = "?limit=" + _limit + "&page=" + _currentPage;

            if (_params.hasOwnProperty('interval') && _params.interval.length) {

                params += "&init_at=" + Vue.moment(_params.interval[0]).format('YYYY-MM-DD')
                        + "&end_at=" + Vue.moment(_params.interval[1]).format('YYYY-MM-DD');
            }

            if (_params.user_id != null) {
                params += "&user_id=" + _params.user_id;
            }

            if (_params.enabled == 1) {
                params += "&enabled=" + _params.enabled;
            }

            if (_params.leads_status_id != null) {
                params += "&leads_status_id=" + _params.leads_status_id;
            }
            
            if (_params.name != null) {
                params += "&name=" + _params.name;
            }
            
            if (_params.lead_type != null) {
                params += "&lead_type=" + _params.lead_type;
            }

            ApiService.get(route + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    search(_params) {
        return new Promise((resolve, reject) => {
            let params = '?';
            if (_params.phone != null) {
                params += "&phone=" + _params.phone;
            }
            ApiService.get(route + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    get(_id) {
        return new Promise((resolve, reject) => {
            ApiService.get(route, _id).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    getCockpit(_initAt, _endAt, _salesmanId) {
        return new Promise((resolve, reject) => {
            ApiService.get(route, "cockpit?initAt=" + Vue.moment(_initAt).format('YYYY-MM-DD') + "&endAt=" + Vue.moment(_endAt).format('YYYY-MM-DD') + "&salesmanId=" + _salesmanId)
                    .then(({data}) => {
                        resolve(data);
                    }, (error) => {
                        reject(error);
                    });
        });
    },
    add(_module) {
        return new Promise((resolve, reject) => {
            ApiService.post(route, _module).then(({ data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    edit(_id, _module) {
        console.log('data >> ', _module)
        return new Promise((resolve, reject) => {
            ApiService.patch(route, _id, _module).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    rem(_id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(route, _id)
                    .then(({ data }) => {
                        resolve(data);
                    }, (error) => {
                        reject(error);
                    });
        });
    },
    share(_params) {
        return new Promise((resolve, reject) => {
            ApiService.post(route + "/share", _params)
                .then(({data}) => {
                    resolve(data);
                }, (error) => {
                    reject(error);
                });
        });
    }
};

export default administrators;
